$(document).on("click", ".product-form__input.has_size label", function () {

    var expressBox = $(".product-express-shipping");
    var extendedBox = $(".product-extended-delivery");

    var hasExpressDot = $(this).find(".product-express-shipping__dot").length > 0;

    if (hasExpressDot) {
        // Show Express Shipping
        extendedBox.addClass("hidden");
        expressBox.removeClass("hidden");
    } else {
        // Show Extended Delivery
        extendedBox.removeClass("hidden");
        expressBox.addClass("hidden");
    }

});



/**
 * Close menu drawer when .close-drawer is clicked
 * For Dawn theme header drawer (three52 / three52.store)
 */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.close-drawer').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelector('summary.header__icon--menu').click()
    });
  });
});



if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
      this.giftAdded = false;
      this.processingGift = false;
      this.locale = 'en-US';
      this.currency = 'USD';
      this.fixedIcons = false;
    }

    connectedCallback() {
      let total = parseInt(this.dataset.cartTotal, 10);
      let showGift = this.dataset.showGift === 'true';
      let showShipping = this.dataset.showShipping === 'true';
      this.fixedIcons = this.dataset.fixedIcons === 'true';

      this.locale = this.dataset.locale;
      this.currency = this.dataset.currency;

      let shippingMinimum = Math.round(parseInt(this.dataset.minimum, 10) * (Shopify.currency.rate || 1));
      let giftMinimum = this.dataset.giftMinimum ? Math.round(parseInt(this.dataset.giftMinimum, 10) * (Shopify.currency.rate || 1)) : 0;
      let giftVariantId = this.dataset.giftVariantId;

      let activeGoals = [];

      if (showShipping) {
        activeGoals.push({
          type: 'shipping',
          value: shippingMinimum
        });
      }
      if (showGift && giftMinimum > 0) {
        activeGoals.push({
          type: 'gift',
          value: giftMinimum
        });
      }

      activeGoals.sort((a, b) => a.value - b.value);

      let maxThreshold = activeGoals.length > 0 ? activeGoals[activeGoals.length - 1].value : shippingMinimum;

      let percentage = this.calculateBarPercentage(total, activeGoals, maxThreshold);
      this.style.setProperty('--percentage', percentage);

      this.updateIcons(activeGoals, maxThreshold, total);

      let nextGoal = null;

      for (let goal of activeGoals) {
        if (total < goal.value) {
          nextGoal = goal;
          break;
        }
      }

      if (nextGoal) {
        if (nextGoal.type === 'shipping') {
          this.showShippingProgress(total, nextGoal.value);
        } else {
          this.showGiftProgress(total, nextGoal.value);
        }
      } else {
        if (activeGoals.length > 0) {
          let lastGoal = activeGoals[activeGoals.length - 1];
          if (lastGoal.type === 'shipping') {
            this.showShippingSuccess();
          } else {
            this.showGiftSuccess();
          }
        } else {
          if (showShipping) this.showShippingSuccess();
        }
      }

      if (showGift && giftMinimum > 0 && total >= giftMinimum) {
        if (giftVariantId && !this.giftAdded && !this.processingGift) {
          this.addGiftToCart(giftVariantId);
        }
      }
    }

    calculateBarPercentage(total, activeGoals, maxThreshold) {
      if (!this.fixedIcons || activeGoals.length < 2) {
        return (maxThreshold > 0) ? Math.min(total / maxThreshold, 1) : 1;
      }

      const goal1 = activeGoals[0].value;
      const goal2 = activeGoals[1].value;

      if (total < goal1) {
        return (total / goal1) * 0.5;
      } else if (total >= goal1 && total < goal2) {
        const range = goal2 - goal1;
        const progressInRange = total - goal1;
        const relativePercent = progressInRange / range;
        return 0.5 + (relativePercent * 0.5);
      } else {
        return 1;
      }
    }

    showShippingProgress(total, threshold) {
      this.hideAllTexts();
      const container = this.querySelector('.fs-shipping-messages');
      const remainingText = container.querySelector('.free-shipping--text-remaining');
      const amountSpan = remainingText.querySelector('span');
      
      if (container) container.classList.remove('fs-hidden');
      if (remainingText) remainingText.style.display = 'block';

      let diff = threshold - total;
      if (amountSpan) amountSpan.innerHTML = formatMoney(diff, this.locale, this.currency);

      const fullText = container.querySelector('.free-shipping--text-full');
      if (fullText) fullText.style.display = 'none';
    }

    showGiftProgress(total, threshold) {
      this.hideAllTexts();
      const container = this.querySelector('.fs-gift-messages');
      const remainingText = container.querySelector('.free-gift--text-remaining');
      const amountSpan = remainingText.querySelector('span');

      if (container) container.classList.remove('fs-hidden');
      if (remainingText) remainingText.style.display = 'block';

      let diff = threshold - total;
      if (amountSpan) amountSpan.innerHTML = formatMoney(diff, this.locale, this.currency);

      const fullText = container.querySelector('.free-gift--text-full');
      if (fullText) fullText.style.display = 'none';
    }

    showShippingSuccess() {
      this.hideAllTexts();
      const container = this.querySelector('.fs-shipping-messages');
      const remainingText = container.querySelector('.free-shipping--text-remaining');
      const fullText = container.querySelector('.free-shipping--text-full');

      if (container) container.classList.remove('fs-hidden');
      if (remainingText) remainingText.style.display = 'none';
      if (fullText) fullText.style.display = 'block';
    }

    showGiftSuccess() {
      this.hideAllTexts();
      const container = this.querySelector('.fs-gift-messages');
      const remainingText = container.querySelector('.free-gift--text-remaining');
      const fullText = container.querySelector('.free-gift--text-full');

      if (container) container.classList.remove('fs-hidden');
      if (remainingText) remainingText.style.display = 'none';
      if (fullText) fullText.style.display = 'block';
    }

    hideAllTexts() {
      const shipMsg = this.querySelector('.fs-shipping-messages');
      const giftMsg = this.querySelector('.fs-gift-messages');
      if (shipMsg) shipMsg.classList.add('fs-hidden');
      if (giftMsg) giftMsg.classList.add('fs-hidden');
    }

    updateIcons(activeGoals, maxThreshold, total) {
      const shippingIcon = this.querySelector('.shipping-milestone');
      const giftIcon = this.querySelector('.gift-milestone');

      if (shippingIcon) shippingIcon.classList.add('fs-hidden');
      if (giftIcon) giftIcon.classList.add('fs-hidden');

      activeGoals.forEach((goal, index) => {
        let icon = (goal.type === 'shipping') ? shippingIcon : giftIcon;
        if (icon) {
          icon.classList.remove('fs-hidden');
          let pos;

          if (this.fixedIcons) {
            if (activeGoals.length > 1) {
              pos = (index === 0) ? 50 : 100;
            } else {
              pos = 100;
            }
          } else {
            pos = (goal.value / maxThreshold) * 100;
          }

          icon.style.left = `${pos}%`;

          if (total >= goal.value) icon.classList.add('achieved');
          else icon.classList.remove('achieved');
        }
      });
    }

    async addGiftToCart(variantId) {
      this.processingGift = true;
      try {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        const giftInCart = cart.items.some(item =>
          item.variant_id === parseInt(variantId)
        );

        if (giftInCart) {
          this.giftAdded = true;
          this.processingGift = false;
          return;
        }

        const formData = {
          items: [{
            id: variantId,
            quantity: 1
          }]
        };

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        if (response.ok) {
          this.giftAdded = true;
          if (typeof window.theme !== 'undefined' && window.theme.cart) window.theme.cart.refresh();
          else {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('theme:cartchanged'));
          }
          this.showGiftNotification();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.processingGift = false;
      }
    }

    showGiftNotification() {
      const notification = document.createElement('div');
      notification.className = 'free-gift-notification';
      notification.innerHTML = '🎁 Free gift added to your cart!';
      document.body.appendChild(notification);
      setTimeout(() => notification.classList.add('show'), 100);
      setTimeout(() => {
        notification.classList.remove('show');
        setTimeout(() => notification.remove(), 300);
      }, 3000);
    }
  }
  customElements.define('free-shipping', FreeShipping);
}

function formatMoney(amount, locale, currency) {
  const loc = locale || 'en-US';
  const curr = currency || 'USD';

  return new Intl.NumberFormat(loc, {
    style: "currency",
    currency: curr,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount / 100);
}